import React, { useState, useContext, useEffect, useHistory } from 'react';
import { Link } from 'react-router-dom';
import { gql, useQuery, useApolloClient } from '@apollo/client';
import UserContext from '../context/UserContext';

// Import the SVG icons from the assets folder
import MenuIcon from '../assets/menu-icon.svg';
import MessageIcon from '../assets/message-icon.svg';
import ProfileIcon from '../assets/profile-icon.svg';
import SternaLogo from '../assets/sterna logo.png';
import Profile from './Profile';

const GET_MENUS = gql`
  query GetMenus($place: String, $lang: String, $type: String, $accLvl: Int ) {
    Tbl_Menu_Item(
      where: { place: { _eq: $place }, lang: { _eq: $lang }, type: { _eq: $type },  acc_lvl: { _gte: $accLvl } }
      order_by: { priority: asc }
    ) {
      id
      title
      link
      acc_lvl
    }
  }
`;

const Header = () => {

  const { users, setUsers } = useContext(UserContext);
  const client = useApolloClient();
  const [value, setValue] = useState('');
  const [date, setDate] = useState(null);
  const [products, setProducts] = useState([]);

  useEffect(() => {
    const fetchUserDetails = async () => {
      try {
        const username = localStorage.getItem('loginuser');
        const { data } = await client.query({
          query: gql`
            query GetUserDetails($username: String!) {
              tbl_user_detail(where: { user_name: { _eq: $username } }) {
                user_name
                user_type
                firm_main_code
                firm_sub_code
                dpr_main_code
                dpr_sub_code
                user_lang
                data_lang
                acs_id

              }
            }
          `,
          variables: { username },
        });

        const userDetails = data.tbl_user_detail[0];
        localStorage.setItem('lang', userDetails.user_lang);

        setUsers((prevUsers) => ({
          ...prevUsers,
          usernames: userDetails.user_name,
          usertype: userDetails.user_type,
          firmcode: userDetails.firm_main_code,
          subfirmcode: userDetails.firm_sub_code,
          userDprMain: userDetails.dpr_main_code,
          userDprSub: userDetails.dpr_sub_code,
          userLang: userDetails.user_lang,
          dataLang: userDetails.data_lang,
          accLvl: userDetails.acs_id,
          
        }));
      } catch (error) {
        console.log("Error fetching user details:", error);
      }
    };

    fetchUserDetails();
  }, [client, setUsers]);

  

  

  useEffect(() => {
    setUsers((prevUsers) => ({
      ...prevUsers,
      placeSide: "1"
    }));
  }, []);


 
  const place = "1000"; //users.placeSide; //1000 header place
  const lang = users.userLang;
  const type = users.usertype;
  const accLvl = users.accLvl;

  const { loading, error, data } = useQuery(GET_MENUS, {
    variables: { place, lang, type, accLvl },
  });

  const [isMenuOpen, setMenuOpen] = useState(false);
  const [isMessageOpen, setMessageOpen] = useState(false);
  const [isProfileOpen, setProfileOpen] = useState(false);

  if (loading) return <p>Loading header...</p>;
  if (error) return <p>Error: {error.message}</p>;

  const menuItems = data.Tbl_Menu_Item;
  
  function handleClick() {
   
    window.location.href = '/';
  // <Link to={"/"}></Link>
   
 
    
  }
  

  const handleLogout = () => {
    // Clear local storage or perform any logout logic
    localStorage.clear();

    // Refresh the page
    window.location.reload()
  };

  return (
    <nav className="flex items-center justify-between flex-wrap bg-gray-50 p-6 z-[9999]">
      <div className="flex items-center flex-shrink-0 text-white mr-28 cursor-pointer">
        <img
          className="fill-current h-12 w-24 mr-2"
          width="150"
          height="55"
          viewBox="0 0 54 154"
          src={SternaLogo}
          alt="Logo"
          onClick={handleClick}
          
           
         
        />
       
      </div>
      <div className="block lg:hidden">
        <button className="flex items-center px-3 py-2 border rounded text-teal-200 border-teal-400 hover:text-white hover:border-white">
          <svg
            className="fill-current h-3 w-3"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
          >
            <title>Menu</title>
            <path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z" />
          </svg>
        </button>
      </div>
      <div className="w-full block flex-grow lg:flex lg:items-center lg:w-auto">
        <div className="text-base lg:flex-grow">
          {menuItems.map((menuItem) => (
            <Link
              key={menuItem.id}
              to={menuItem.link}
              className="block mt-4 lg:inline-block lg:mt-0 text-fuchsia-900 hover:text-fuchsia-500 mr-4"
            >
              {menuItem.title}
            </Link>
          ))}
        </div>
      </div>

      {/* SVG Icons
      {/* SVG Icons and Dropdown Lists */}
      <div className="flex items-center">
        {/* Menu Icon */}
        <button
          onClick={() => setMenuOpen(!isMenuOpen)}
          className="text-gray-600 focus:outline-none mr-4"
        >
          <img src={MenuIcon} alt="Menu" className="w-6 h-6 cursor-pointer" />
        </button>
        {isMenuOpen && (
          <div className="absolute bg-white shadow-lg rounded mt-2">
            {/* Dropdown menu content */}
            
            {/* ... */}
          </div>
        )}

        {/* Message Icon */}
        <button
          onClick={() => setMessageOpen(!isMessageOpen)}
          className="text-gray-600 focus:outline-none mr-4"
        >
          <img src={MessageIcon} alt="Message" className="w-6 h-6 cursor-pointer" />
        </button>
        {isMessageOpen && (
          <div className="absolute bg-white shadow-lg rounded mt-2">
            {/* Dropdown menu content */}
            murat
            {/* ... */}
          </div>
        )}

        {/* Profile Icon */}
        <button
          onClick={() => setProfileOpen(!isProfileOpen)}
          className="text-gray-600 focus:outline-none mr-4 relative p-1 hover:text-violet-200  z-[9999]"
        >
          <img src={ProfileIcon} alt="Profile" className="w-6 h-6 cursor-pointer" />
        </button>
        {isProfileOpen && (
          <div className="grid-cols-1 w-48 pt-2 pl-2 absolute top-10 right-4 transform translate-y-6 bg-white shadow-lg rounded origin-top">
            {<h1>"user" </h1>}
            {<h1>{users.usernames}</h1>}
             <button onClick={handleLogout}>Logout</button>

            {/* ... */}
          </div>
        )}

        {/* User Name */}
        <span className="text-gray-800 text-sm font-medium mr-4">{users.usernames}</span>
      </div>
    </nav>
  );
};

export default Header;
